"use client";

import Checkbox from "@/components/atoms/FormComponents/Checkbox";
import Input from "@/components/atoms/FormComponents/Input/Input";
import Select from "@/components/atoms/FormComponents/Select";
import SubmitButton from "@/components/atoms/FormComponents/SubmitButton";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import cn from "clsx";
import styles from "../ConnectModalForm/ConnectModalForm.module.scss";
import { trackingDetails } from "@/api/getOtherFormDetails";
import { useRouter, usePathname } from "next/navigation";
import { COUNTRY_CALLING_CODES } from "@/helpers/constants";
import { useOTPContext } from "@/components/sections/CommonModals/context";
import { getProgramId, getSpecializationValue } from "../LandingPageConnectModalForm/utils";
import { pushToDataLayer } from "@/helpers/gtag";
import { StorageService } from "@/helpers/storage.service";
import ApplicationFormRedirectLoader from "../../ApplicationFormRedirectLoader/ApplicationFormRedirectLoader";
import { useInView } from "react-intersection-observer";
import { ModalContext } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import useOnScreen from "@/helpers/Onscreen";
import { getGlobalStateValue, updateStateSession, fetchIpInfoFunNew, ALL_COUNTRIES} from "@/context/utils";
import ConsentFormPara from "@/components/common/utils/consentFormPara";
import { formatDate } from "../ConnectModalForm/utils";
import CountryDropdownGlobal from "@/components/atoms/FormComponents/CustomDropdownGlobal/CustomDropdownGlobal";


const errorAccordingToFieldName = {
    fullName: "Please enter valid full name",
    countryCode: "Please enter valid country code",
    phoneNumber: "Please enter valid phone number",
    emailId: "Please enter valid email address",
    isTermsAccepted: "Please accept terms & conditions",
};

const countryCodeOptions = COUNTRY_CALLING_CODES;


const getCssConfig = ({ isNewLeadForm = false }) => ({
  formWrapper: isNewLeadForm ? `${styles.newLeadFormWrapper}` : "h-[100%]",
  firstName: isNewLeadForm ? `${styles.newLeadFormFirstName}` : cn(styles.inputWrapper, "flex gap-4"),
  phoneNumber: isNewLeadForm ? `${styles.newLeadFormPhone}` : cn(styles.commonMargins),
  email: isNewLeadForm ? `${styles.newLeadFormEmail}` : cn(styles.commonMargins, styles.emailContainer, "flex gap-4"),
  termsConditions: isNewLeadForm
    ? cn(styles.commonMargins, "flex items-start gap-[17px] mt-4")
    : cn(styles.commonMargins, "flex items-start gap-[17px]"),
});

export default function ProgramPageConnectModalForm(props: {
    // handleSubmit?: any;
    ProgramId?: any;
    associatedPrograms : Array<ProgramDetails>
    isNewLeadForm?: boolean
    NewBannerUI?: NewBannerUI
    isMobile?: boolean
    setLeadFailed?: (x:boolean) => void
    isSeatsFilledEnabled :boolean
    Numbers: number
    
}) {
    const path = usePathname();
    const router = useRouter();
   
    const closeModal = () => {
        router.replace(path, {
            scroll: false,
        });
    };
    const [message, setMessage] = useState(null);
    const [isLoading, loading] = useState(false
    );
    const { handleSendOTP, isOTPLoading, setShowLoader, setLeadResponse, setIsHeaderHidden, setIsNewSignInFlow } = useOTPContext();
    const [ipStackDetails, setIpStackDetails] = useState(null);
    const [formValues, setFormValues] = React.useState({
        fullName: "",
        countryCode: "+91",
        phoneNumber: "",
        emailId: "",
        programId: props.ProgramId,
        isTermsAccepted: true,
    });
    const [errors, setErrors] = React.useState({
        fullName: "",
        countryCode: "",
        phoneNumber: "",
        emailId: "",
        programId: "",
        isTermsAccepted: "",
    });
    const { modalState, modalDispatch } = useContext(ModalContext)
    const isSessionModalActive = StorageService.get("timeConnectModal")
    const isNational = formValues.countryCode === "+91"
    const isCalledOnce = useRef(false);

    const ref = useRef()
    const {ref: formRef, inView} = useInView();
    const setRefs = useCallback(
      (node) => {
        ref.current = node;
        formRef(node);
      },
      [formRef],
    );

    const onScreen = useOnScreen(ref)  ;

    useEffect(()=>{
      const enrollNowRef = document.getElementById('enroll-now-cta')
      
      if(enrollNowRef) {
        if(onScreen){
          enrollNowRef.style.display = "none";
        }else{
          enrollNowRef.style.display = "block";
        }
      }  
      
    }, [onScreen])
    
  useEffect(() => {
    if(!isSessionModalActive){
      modalDispatch({
        type: IModalActions.UpdateModal,
        data: { 
          modalType: ModalTypes.CallUsModal, 
          isModalOpen: false, 
          isModalForceClose: inView 
        }
      });
    }
  }, [inView]);


  useEffect(()=>{
    setIsNewSignInFlow(true)
  },[])

  useEffect(() => {
    let isValid = false;
  
    if (formValues.countryCode === '+91') {
      isValid = regexForInputs["phoneNumber"].test(formValues.phoneNumber);
    } else {
      const regexToUse = /^[1-9][0-9]{6,14}$/
      isValid = regexToUse.test(formValues.phoneNumber);
    }
  
    if (isValid) {
      const handler = setTimeout(() => {
        leadCheckOnCompletion();
      }, 2000);
  
      return () => {
        clearTimeout(handler);
      };
    }
  }, [formValues.phoneNumber, formValues.countryCode]);


  useEffect(() => {
    let isValid = false;

    if (regexForInputs["emailId"].test(formValues.emailId) ) {
        isValid=true;
    }
  
    if (isValid) {
      const handler = setTimeout(() => {
        leadCheckOnCompletion();
      }, 2000);
  
      return () => {
        clearTimeout(handler);
      };
    }
  }, [formValues.emailId]);


    const [isFormValid, setIsFormValid] = React.useState(false);
    const [loadingCount, setLoadingCount] = React.useState(3);
    const [isApplicationRedirectLoaderDisabled, setApplicationRedirectLoaderDisabled] =
      useState(true);
    const Custom10Value = props?.associatedPrograms[0]?.attributes?.BasicDetails?.Custom10PgType;
    const programType = props?.associatedPrograms[0]?.attributes?.BasicDetails?.ProgramType;41
    const isCertification = programType === "Certification";
  
    
    const counterInterval = useRef(null);
    
    const { CTABackgroundColorMobile, CTABackgroundColorDesktop, CTAColorMobile, CTAColorDesktop } =
      props.NewBannerUI || {};

    const btnColors ={
        bg: props.isMobile ? CTABackgroundColorMobile: CTABackgroundColorDesktop,
        color: props.isMobile ? CTAColorMobile: CTAColorDesktop
      }

    const { isNewLeadForm } = props

    const apiResponseURL = useRef(null)

    const cssConfig = getCssConfig({ isNewLeadForm })

    const regexForInputs: any = {
        fullName: /^[a-zA-Z][a-zA-Z ]{2,49}$/,
        countryCode:  /^\+\d{1,3}(?:-\d{1,4})?$/,
        phoneNumber: /^[1-9][0-9]{9}$/,
        emailId: /^[a-zA-Z0-9+_.-]+@(?:[a-zA-Z0-9.-]+\.)+([a-zA-Z]{2,})$/,
        isTermsAccepted: /^true$/,
    };

    // If country code is +91 then only allow 10 digits else allow 7-13 digits
    const handlePhoneNumberChange = (
        value: string,
        countryCodeVal: string = formValues.countryCode
    ) => {
        let regexToUse = regexForInputs["phoneNumber"];
        if (countryCodeVal != "+91") {
            regexToUse = /^[1-9][0-9]{6,14}$/;
        }
        if (!regexToUse.test(value)) {
            setErrors((prev) => ({
                ...prev,
                phoneNumber: errorAccordingToFieldName["phoneNumber"],
            }));
        } else {
            setErrors((prev) => ({ ...prev, phoneNumber: "" }));
        }
        setFormValues((prev) => ({ ...prev, phoneNumber: value }));      
    };

    const leadCheckOnCompletion = async () => {
        try {
          let uniqueId = localStorage.getItem("uniqueLeadId");
          
          if (!uniqueId) {
          uniqueId = `uid-${Date.now()}-${Math.floor(Math.random() * 10000)}`;
          localStorage.setItem("uniqueLeadId", uniqueId);
          }
        
          const response = await fetch("/api/leadsquared.com/lead-check", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            PhoneNo: formValues.phoneNumber,
            EmailID: formValues.emailId,
            Name: formValues.fullName,
            CountryCode: formValues.countryCode,
            PageUrl: window.location.href,
            CommConsent: formatDate(new Date()),
            UniqueId: uniqueId,
          }),
          });
        
          if (!response.ok) {
          throw new Error("Failed to submit phone number");
          }
        } catch (error) {
          console.error("Error submitting phone number:", error);
        }
        };

    const handleSingleFieldChange = (
        fieldName: string,
        value: string | boolean
    ) => {
        if (
            (!regexForInputs[fieldName]?.test(value) &&
                fieldName !== "degree" &&
                fieldName !== "program") ||
            value.toString().includes("Select")
        ) {
            setErrors((prev) => ({
                ...prev,
                [fieldName]: errorAccordingToFieldName[fieldName],
            }));
        } else {
            setErrors((prev) => ({ ...prev, [fieldName]: "" }));
        }
        setFormValues((prev) => ({ ...prev, [fieldName]: value }));

        // If country code is changed then validate phone number again
        if (fieldName === "countryCode") {
            handlePhoneNumberChange(formValues.phoneNumber, value.toString());
        }
    };

    const updateCountryCode = (value) => {
      const newFormValues  = { ...formValues }
      newFormValues['countryCode'] = value;
      newFormValues['phoneNumber'] = "";
      setFormValues(newFormValues);
    }
  
    const checkAllFieldsValid = () => {
        return (
            formValues.fullName !== "" &&
            formValues.phoneNumber !== "" &&
            formValues.emailId !== "" &&
            formValues.isTermsAccepted &&
            Object.values(errors).every((x) => x === "")
        );
    };

    const resetState = ()=>{
      setIsHeaderHidden(false)
      setApplicationRedirectLoaderDisabled(true)
      setFormValues({
        fullName: "",
        countryCode: "+" + ipStackDetails?.location?.calling_code || "91",
        phoneNumber: "",
        emailId: "",
        programId: props.ProgramId,
        isTermsAccepted: true,
      });
      setLoadingCount(3)
    }
    
    const startLoader = () => {
      counterInterval.current = setInterval(() => {
        setLoadingCount((count) => {
          if (count < 1) {
            clearInterval(counterInterval.current);

            window.location.href = apiResponseURL.current + "&e=1"
            
            setTimeout(resetState, 3000);

            return 0;
          } else {
            return count = count - 1;
          }
        });
      }, 1000);
    };

    const checkLeadFail = (status:boolean) =>{
      props.setLeadFailed(status)
    }

    const handleSubmit = (payload) => {

        const form = {
          name: payload.fullName,
          phone: payload.phoneNumber,
          countryCode: payload.countryCode,
          email: payload.emailId,
          PROGRAM_ID: getProgramId({
            programId: props.ProgramId,
            associatedPrograms: props.associatedPrograms,
          }),
          Custom6: getSpecializationValue({ associatedPrograms: props.associatedPrograms }),
          consent: true,
        };
    
        if(formValues?.countryCode!=="+91" && !isNewLeadForm){    
            window.location.href = "/thankyou";
        }

        const tracking = trackingDetails();
        const leadSquareApiCall = (payload:any) => {
            return fetch("/api/leadsquared.com/lead-create", {
              method: "POST",
              body: JSON.stringify({
                ipstack: ipStackDetails,
                form: { ...form, ...payload },
                meta: {
                  ...tracking,
                  utm_medium: tracking?.utm_medium || "request_a_callback",
                },
              }),
            });
        }

        const verifyOtpCb = async () => {
          setShowLoader(false);
          if(path.includes('/lp-nw')){
            setShowLoader(true);
          }
          if (isNewLeadForm && apiResponseURL.current) {
            setApplicationRedirectLoaderDisabled(false)
            startLoader();
          } else {
            window.location.href ="/thankyou";
          }
        };

        const cb = () => {
            return new Promise((resolve, reject) => {
                loading(true);
                
                const connectCounsellorApiCall = (status:boolean)=> fetch("/api/connect-counsellor", {
                    method: "POST",
                    body: JSON.stringify({
                        ipstack: ipStackDetails,
                        form,
                        meta: {
                            ...tracking,
                            utm_medium: tracking?.utm_medium || "request_a_callback",
                        },
                        status
                    }),
                });
                const setCounselorData = async (status:boolean) => {
                  try{
                    const counsellorResponse = await connectCounsellorApiCall(status);
                    const counsellorData = await counsellorResponse.json();
                    return counsellorData
                  }catch(err){
                    console.error("Error in councelor udpate data", err)
                  }
                }

                function getEvent(event) {
                    StorageService.set("mFitlerKeyDetails", event.detail)
                }
                async function performApiCalls() {
                  try {
                    loading(true);
                    let leadSquareResponse;
                    try {
                      const response = await leadSquareApiCall({ Custom5: "Not Verified", Custom10: Custom10Value || "" });
                      if (typeof response === 'string') {
                        leadSquareResponse = JSON.parse(response);
                      } else {
                        leadSquareResponse = await response.json();

                        fetch("/api/prospect-activity",{
                          method: "post",
                          body: JSON.stringify({ leadResponse: leadSquareResponse.response }),
                        }).then(res=> {
                          // do nothing
                        })
                      }
                      if (leadSquareResponse?.success) {
                        const resp = leadSquareResponse?.response || {};
                        pushToDataLayer({
                          "LSQ_ID" : resp?.ProspectId
                        });
                        pushToDataLayer({
                            "event" : "MFilter_OTP_Verified_New",
                            "LSQ_ID" : resp?.ProspectId
                        })
                        document.addEventListener("mfilterit:botDetect", getEvent)

                        StorageService.set("LSQ_ID", resp?.ProspectId)
                        updateStateSession({
                          formSectionName : "Apply Now",
                          leadStartingCta : "NA"
                        })
                        pushToDataLayer({
                          event: "lead_submit",
                          cta_text: "Submit",
                          lead_starting_cta: "NA",
                          lead_starting_url : window.location.href || "NA",
                          lead_id : resp?.ProspectId || "NA",
                          section_name : getGlobalStateValue('parentSection') || "NA",
                          status: "success",
                          error_message: "NA",
                          lead_type: "lead_submit_1",
                          page_type : getGlobalStateValue('pageType'),
                          page_url : window?.location?.href || "NA"
                        });

                        
                        window.webengage.track("Lead Form Filled", {
                          "Student Nationality": payload.countryCode == "+91" ? "National" : "International",
                          "First Name": payload.fullName,
                          "Phone Number": payload.countryCode + payload.phoneNumber,
                          "Email ID": payload.emailId,
                          "Form Type":"Apply",
                          "Section Name": getGlobalStateValue('parentSection') || ""
                        }) 

                        window.webengage.user.login(resp?.ProspectId);

                        window.webengage.user.setAttribute('we_email', payload.emailId);
                        window.webengage.user.setAttribute('we_first_name', payload.fullName);
                        window.webengage.user.setAttribute('we_phone', payload.countryCode + payload.phoneNumber);                   


                        apiResponseURL.current = leadSquareResponse.response.URL || ''

                        if (formValues?.countryCode !== "+91" && !isNewLeadForm) {
                          window.location.href = "/thankyou";
                          return
                        } else if (formValues?.countryCode !== "+91" && isNewLeadForm) {
                          // bye pass the OTP
                          verifyOtpCb();
                        }

                        if (typeof setLeadResponse === "function") {
                          setLeadResponse(resp);
                        }
                        setIsHeaderHidden(true)
                        resolve(resp)
                        await setCounselorData(true)
                      }
                    } catch (error) {
                      console.error("LeadSquare API call failed:", error);
                      pushToDataLayer({
                        event: "lead_submit",
                        cta_text: "Submit",
                        lead_starting_cta: "NA",
                        lead_starting_url : window.location.href || "NA",
                        lead_id : "NA",
                        section_name : getGlobalStateValue('parentSection') || "NA",
                        status: "fail",
                        error_message: "LeadSquare API call failed.",
                        lead_type: "lead_submit_1",
                        page_type : getGlobalStateValue("pageType"),
                        page_url : window?.location?.href || "NA"
                      });
                      setShowLoader(false);
                      setIsHeaderHidden(true)
                      const counselorApiData = await setCounselorData(false)
                    }
        
                    if(!leadSquareResponse?.success){
                      setShowLoader(false);
                      setIsHeaderHidden(true)
                      const counselorApiData = await setCounselorData(false)
                    }
                    resolve(leadSquareResponse?.response);
        
                  } catch (error) {
                    console.error("Error:", error);
                    const errorMessage = "Error occurred.";
                    pushToDataLayer({
                      event: "lead_submit",
                      cta_text: "Submit",
                      lead_starting_cta: "NA",
                      lead_starting_url : window.location.href || "NA",
                      lead_id : "NA",
                      section_name : getGlobalStateValue('parentSection') || "NA",
                      status: "fail",
                      error_message: errorMessage,
                      lead_type: "lead_submit_1",
                      page_type : getGlobalStateValue("pageType"),
                      page_url : window?.location?.href || "NA"
                    });
                    setMessage(errorMessage);
                    reject(error);
                  } finally {
                    loading(false);
                  }
                }
                performApiCalls();
            });
        };
  
        handleSendOTP(form, cb, null, verifyOtpCb, checkLeadFail);
    };
    const makeFormSubmission = useCallback(
        (e: any) => {
            e.preventDefault();
            const isValid = checkAllFieldsValid();
            if (isValid) {
                handleSubmit(formValues);
            }
        },
        [formValues]
    );


    useEffect(() => {
      if(!isCalledOnce.current){
  
       fetchIpInfoFunNew({ setIpStackDetails, setFormValues });

        isCalledOnce.current = true;
      }
      

        return ()=>{
            clearInterval(counterInterval.current)
        }
    }, []);

    useEffect(() => {
        const isFormValid = checkAllFieldsValid();
        setIsFormValid(isFormValid);
    }, [formValues]);

    const handleFieldBlur = (fieldName: string, value: string, error: string | undefined) => {
      pushToDataLayer({
        'event': 'form_filled',
        'field_name': fieldName,
        'option_selected': value || "NA",
        'error_message': error || "NA",
        'section_name': getGlobalStateValue("parentSection") || "NA",
        'page_type' : getGlobalStateValue("pageType"),
        'page_url' : window?.location?.href || "NA"
      });
    };

    return (
      <>
        {!isApplicationRedirectLoaderDisabled ? (
          <ApplicationFormRedirectLoader redirectTime={loadingCount} />
        ) : (
          <form
            ref={setRefs}
            onSubmit={makeFormSubmission}
            className={cn(styles.root, "h-full flex flex-col justify-between	")}
          >
            <div className={cssConfig.formWrapper}>
              <div className={cssConfig.firstName}>
                <div className="w-[100%]">
                  <label htmlFor="input">
                    full name <span className="text-xl">*</span>
                  </label>
                  <Input
                    placeholder="Enter your full name"
                    value={formValues.fullName}
                    onChangeFunc={(value: string) => handleSingleFieldChange("fullName", value)}
                    onBlur={() => handleFieldBlur("fullName", "", errors.fullName)}
                  />
                  <p className={cn(styles.error)}>{errors.fullName}</p>
                </div>
              </div>
              <div className={cssConfig.phoneNumber}>
                <div className="w-[100%]">
                  <label htmlFor="input">
                    phone number <span className="text-xl">*</span>
                  </label>
                  <div className="flex gap-[6px]">
                    <div className="md:mt-[0.36rem] mt-[0.4166666667rem]">
                <CountryDropdownGlobal
                  onChangeFunc={(value: string) => handleSingleFieldChange("countryCode", value)}
				          countries={ALL_COUNTRIES}
				          countryCode={formValues.countryCode}
				          updateCountryCode={updateCountryCode}
                  additionalStyle="sm:h-auto md:h-[2.6rem] h-[2.75rem] lg:h-[2.25rem]"
                  isDark={false}
                />
                    </div>
                    <div className="w-full">
                      <Input
                        placeholder="Enter your no."
                        value={formValues.phoneNumber}
                        onChangeFunc={handlePhoneNumberChange}
                        onBlur={() => handleFieldBlur("phoneNumber", "", errors.phoneNumber)}
                      />
                    </div>
                  </div>
                  <p className={cn(styles.error)}>{errors.countryCode || errors.phoneNumber}</p>
                </div>
              </div>

              <div className={isNational && isCertification ? cssConfig.email : styles.newLeadFormEmailFullWidth}>
                <div className="w-full">
                  <label htmlFor="input">
                    email id <span className="text-xl">*</span>
                  </label>
                  <Input
                    placeholder="abc@xyz.com"
                    value={formValues.emailId}
                    onChangeFunc={(value: string) => handleSingleFieldChange("emailId", value)}
                    onBlur={() => handleFieldBlur("emailId", "", errors.emailId)}
                    
                  />
                  <p className={cn(styles.error)}>{errors.emailId}</p>
                </div>
              </div>
            </div>

            <div className={cssConfig.termsConditions}>
              <div className="shrink-0">
                <Checkbox
                  name="consent"
                  value={formValues.isTermsAccepted}
                  onChangeFunc={(value: boolean) =>
                    handleSingleFieldChange("isTermsAccepted", value)
                  }
                  onBlur={() => handleFieldBlur("isTermsAccepted", "", errors?.isTermsAccepted || "NA")}
                />
              </div>
              <p className={cn(styles.authorization)}>
               <ConsentFormPara/>
              </p>
            </div>

            {/* <p className={cn(styles.error)}>{errors.degree}</p> */}

            <SubmitButton
              text={isLoading || isOTPLoading ? "Submitting" : "Submit"}
              isDisabled={isLoading || isOTPLoading || !isFormValid}
              bgColor={btnColors.bg}
              textColor={btnColors.color}
            />
            {message && message}
            {(props.isSeatsFilledEnabled && <div style={{
              width: '100%',
              backgroundColor: '#e0e0e0',
              borderRadius: '20px',
              overflow: 'hidden',
              position: 'relative',
              marginTop: '20px'
            }}>
              <div style={{
                width: `${props.Numbers}%`,
                backgroundColor: '#1275d8',
                height: '30px',
                transition: 'width 0.3s ease',
                animation: 'progress-bar-slide 2s linear infinite',
                backgroundImage: 'linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent)',
                backgroundSize: '30px 30px'
              }}>
                <div style={{
                  width: '100%',
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  textAlign: 'center',
                  zIndex: 2
                }}>
                  <span style={{
                    fontWeight: 'bold',
                    fontSize: '14px',
                    color: '#FFFFFF',
                    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.7)'
                  }}>{props.Numbers}%</span>
                  <span style={{
                    fontWeight: 400,
                    fontSize: '14px',
                    marginLeft: '5px',
                    color: '#FFFFFF',
                    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.7)'
                  }}>Seats filled</span>
                </div>
              </div>
            </div>)}
            {(!props.isSeatsFilledEnabled && <div style={{marginBottom: '0rem'}}></div>)}
            
            <style jsx>{`
              @keyframes progress-bar-slide {
                from { background-position: 0 0; }
                to { background-position: 30px 0; }
              }
            `}</style>

          </form>
        )}
      </>
    );
}
